import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Box,
  Button,
  debounce,
  Dialog,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { HeaderFiltro } from "../header-filtro";
import { EscolaridadesFilterPreview } from "./escolaridades-filter-preview";
import { useState } from "react";
import { Transition } from "../../../../../../components";
import {
  EscolaridadeKeys,
  escolaridadeKeyToLabel,
} from "../../../../../../../application/models/geo-veles/IEscolaridade";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
// Icons
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";
import { theme } from "../../../../../../styles";

export const FiltroEscolaridade = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
  // Use State
  const [open, setOpen] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  // Hook
  const { addEscolaridadeFilter } = useProjetosService();

  return (
    <>
      <HeaderFiltro
        titulo="Escolaridade"
        descricao={
          <>
            <Typography>
              Esta opção permite buscar pessoas através da escolaridade.
            </Typography>
            <Typography style={{ marginBottom: "10px" }}>
              Você pode abrir a lista de escolaridades disponíveis e selecionar
              quantas desejar.
            </Typography>
            <Typography>
              Caso nenhuma opção seja selecionada, consideraremos todas.
            </Typography>
          </>
        }
      />

      <Box my={3} mt={5}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              fullWidth
              onClick={() => {
                setOpen(true);
              }}
              endIcon={<AddIcon />}
            >
              <Typography variant="h6" fontWeight="bold">
                Clique para adicionar uma nova escolaridade
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12}>
            <EscolaridadesFilterPreview />
          </Grid>
        </Grid>
      </Box>

      <Dialog
        fullScreen
        TransitionComponent={Transition}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
              component="div"
              textTransform="uppercase"
            >
              Selecionar escolaridade
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={() => {
                setOpen(false);
              }}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>
        <Box p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Digite a escolaridade"
                placeholder="Digite a escolaridade"
                onChange={debounce((e) => setSearchTerm(e.target.value), 500)}
              />
            </Grid>
          </Grid>
        </Box>
        <Grid container>
          <Grid item xs={6}>
            <List>
              {EscolaridadeKeys.map((escolaridade, index) => {
                if (
                  !escolaridade
                    ?.toUpperCase()
                    .includes(searchTerm.toUpperCase())
                ) {
                  return null;
                }

                if (filtrosSelecionados?.escolaridade?.includes(escolaridade)) {
                  return null;
                }

                return (
                  <ListItem key={escolaridade} style={{ padding: 0 }}>
                    <ListItemButton
                      onClick={() => {
                        addEscolaridadeFilter(escolaridade);
                      }}
                    >
                      <ListItemText
                        primary={escolaridadeKeyToLabel(
                          escolaridade
                        ).toUpperCase()}
                      />
                      <Box>
                        <BookmarkAddIcon />
                      </Box>
                    </ListItemButton>
                    <Divider color={theme.palette.primary.main} />
                  </ListItem>
                );
              })}
            </List>
          </Grid>
          {(filtrosSelecionados?.escolaridade?.length ?? 0) > 0 && (
            <Grid item xs={6}>
              <Box p={3} my={3}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      variant="h5"
                      color="primary"
                      fontWeight="bold"
                      textTransform="uppercase"
                    >
                      Escolaridades selecionadas
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <EscolaridadesFilterPreview />
                  </AccordionDetails>
                </Accordion>
              </Box>
            </Grid>
          )}
        </Grid>
      </Dialog>
    </>
  );
};
